const content = `
window.addEventListener("message", (event)=>{
	if(event.data == "READ_SIG"){
		readSignature()
	}
	else if(event.data == "CLEAR_SIG"){
		clearSignature()
	}
})
`

export default content